import { render, staticRenderFns } from "./FormGenerator.vue?vue&type=template&id=10e6506e&"
import script from "./FormGenerator.vue?vue&type=script&lang=js&"
export * from "./FormGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports